<template>
  <div>
    <AppLayout title="Operadores">
      <template #actions>
        <button type="button" @click="show_newOperator()" class="btn btn-primary">Novo Operador</button>
      </template>

      <div class="table-card">
        <table class="table">
          <thead>
            <tr>
              <th>Id</th>
              <th>Username</th>
              <th>Loja</th>
              <th>Status</th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="operadoritem in lista_operadores">
              <td>{{ operadoritem.id }}</td>
              <td>
                {{ operadoritem.username }}
                <span v-if="!operadoritem.status" class="badge text-bg-secondary ms-1">Inativo</span>
              </td>
              <td>{{ operadoritem.store?.name ?? '' }}</td>
              <td>{{ operadoritem.cashier_status }}</td>
              <td><button v-if="operadoritem.cashier_status == 'Aberto'" @click="closeCashier(operadoritem.id)" type="button" class="btn btn-info btn-sm">Fechar Caixa</button></td>
              <td style="width:50px"><button @click="show_editOperator(operadoritem)" type="button" class="btn btn-info btn-sm"><i class="bi bi-pencil-square"></i></button></td>
              <td style="width:50px"><button @click="show_deletOperator(operadoritem)" :disabled="autorizated_delet == 0" type="button" class="btn btn-danger btn-sm"><i class="bi bi-trash-fill"></i></button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </AppLayout>

    <!-- Modal Operador -->
    <div class="modal fade" id="modal_operador" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div v-if="edit" >
              <h5 class="modal-title">Editar Operador</h5>
            </div>
            <div v-else >
              <h5  class="modal-title">Novo Operador</h5>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form id="form-produto">
              <div class="mb-3">
                <label for="inp_name" class="form-label">Username:</label>
                <input v-model="Operador.username" type="text" class="form-control" name="inp_name" id="inp_name">
              </div>
              <div class="mb-3">
                  <label for="inp_andress" class="form-label">Password:</label>
                  <input v-model="Operador.password" type="text" class="form-control" name="inp_andress" id="inp_andress">
              </div>
              <div class="mb-3" v-if="lista_lojas.length > 1">
                <label for="inp_store" class="form-label">Loja:</label>
                <select v-model="Operador.store_id" class="form-select" id="inp_store">
                  <option v-for="loja in lista_lojas" :key="loja.id" :value="loja.id">{{ loja.name }}</option>
                </select>
              </div>
              <div class="form-check form-switch mb-3" v-if="edit">
                <input v-model="Operador.status" class="form-check-input" type="checkbox" role="switch" id="inp_status">
                <label class="form-check-label" for="inp_status">Ativo (desmarque pra tirar o acesso ao PDV sem apagar o cadastro)</label>
              </div>
              <div class="form-check">
                <input v-model="Operador.can_make_sale" class="form-check-input" type="checkbox" id="inp_can_sale">
                <label class="form-check-label" for="inp_can_sale">Pode vender (abre caixa no PDV)</label>
              </div>
              <div class="form-check">
                <input v-model="Operador.can_manage_product" class="form-check-input" type="checkbox" id="inp_can_stock">
                <label class="form-check-label" for="inp_can_stock">Pode dar entrada/descartar estoque</label>
              </div>
              <div class="form-check">
                <input v-model="Operador.can_manage_customer" class="form-check-input" type="checkbox" id="inp_can_customer">
                <label class="form-check-label" for="inp_can_customer">Pode cadastrar clientes</label>
              </div>
              <div class="form-check">
                <input v-model="Operador.can_manage_onaccount" class="form-check-input" type="checkbox" id="inp_can_onaccount">
                <label class="form-check-label" for="inp_can_onaccount">Pode criar conta fiado (crediário) para clientes</label>
              </div>
              <template v-if="servicesEnabled">
                <div class="form-check">
                  <input v-model="Operador.can_manage_service" class="form-check-input" type="checkbox" id="inp_can_service">
                  <label class="form-check-label" for="inp_can_service">Pode vender serviço</label>
                </div>
                <div class="form-check">
                  <input v-model="Operador.can_manage_budget" class="form-check-input" type="checkbox" id="inp_can_budget">
                  <label class="form-check-label" for="inp_can_budget">Pode emitir orçamento</label>
                </div>
              </template>
            </form>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button type="submit" @click="actionOperator()" class="btn btn-primary">Salvar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Deletar -->
    <div class="modal fade" id="modal_deletar" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Deletar Operador?</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ Operador.username }}</p>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button @click="deleteOperator()" class="btn btn-danger">Deletar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Feedback -->
    <div class="modal fade" id="modal_feedback" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">{{ feedback_error ? 'Não foi possível concluir' : 'Sucesso' }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ msn_feedback }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    <script>
      import {  onMounted, reactive, ref } from 'vue';
      import { Modal } from "bootstrap";
      import AppLayout from "@/components/AppLayout.vue";
      import { operator } from "@/models/operator";
      import { lojas } from "@/models/lojas";
      import { configuracoes } from "@/models/configuracoes";

      export default {
        name: 'OperatorsView',
        components: {
          AppLayout
        },
        setup(props) {
          const lista_operadores = ref([]);
          const lista_lojas = ref([]);
          const Operadores = operator();
          const Lojas = lojas();
          const Configuracoes = configuracoes();
          const servicesEnabled = ref(false);

          var edit = ref(false);
          var msn_feedback = ref('');
          var feedback_error = ref(false);
          var autorizated_delet = ref(true);

          let modal = '';

          var Operador = reactive({
            'id':'',
            'username':'',
            'password':'',
            'store_id':'',
            'status': true,
            'can_make_sale': true,
            'can_manage_product': true,
            'can_manage_customer': true,
            'can_manage_onaccount': true,
            'can_manage_service': true,
            'can_manage_budget': true,
          })

          function openModal(elemento) {
            const modalNovoProduto = document.getElementById(elemento);
            modal = new Modal(modalNovoProduto);
            modal.show();
          };

          function closeModal() {
            modal.hide();
          };

          function limparDados() {
            Operador.id = '';
            Operador.username = '';
            Operador.password = '';
            Operador.store_id = lista_lojas.value.find(l => l.is_default)?.id ?? lista_lojas.value[0]?.id ?? '';
            Operador.status = true;
            Operador.can_make_sale = true;
            Operador.can_manage_product = true;
            Operador.can_manage_customer = true;
            Operador.can_manage_onaccount = true;
            Operador.can_manage_service = true;
            Operador.can_manage_budget = true;
          };

          const show_editOperator = (item) => {
            edit.value = true;
            Operador.id = item.id;
            Operador.username = item.username;
            Operador.password = '';
            Operador.store_id = item.store_id;
            Operador.status = item.status;
            Operador.can_make_sale = item.can_make_sale;
            Operador.can_manage_product = item.can_manage_product;
            Operador.can_manage_customer = item.can_manage_customer;
            Operador.can_manage_onaccount = item.can_manage_onaccount;
            Operador.can_manage_service = item.can_manage_service;
            Operador.can_manage_budget = item.can_manage_budget;
            openModal('modal_operador');
          }

          const show_newOperator = (item) => {
            limparDados();
            edit.value = false;
            openModal('modal_operador');
          }

          const show_deletOperator = (item) => {
            limparDados();
            edit.value = true;
            Operador.id = item.id;
            Operador.username = item.username;
            Operador.password = '';
            openModal('modal_deletar');
          }

          const saveOperator = async () => {
            feedback_error.value = false;
            const result = await Operadores.createItem(Operador);
            if (result === true) {
              closeModal();
              msn_feedback.value = 'Operador cadastrado com sucesso!';
              openModal('modal_feedback');
              limparDados();
              listOperators();
            } else {
              closeModal();
              feedback_error.value = true;
              msn_feedback.value = result;
              openModal('modal_feedback');
            }
          }

          const listOperators = async () => {
            lista_operadores.value = await Operadores.list()
          }

          const listStores = async () => {
            lista_lojas.value = await Lojas.list();
            limparDados();
          }

          async function closeCashier(id) {
            if (await Operadores.closeCashier(id)) {
              msn_feedback.value = 'Caixa fechado com sucesso!';
              openModal('modal_feedback');
              listOperators();
            } else {
              console.log('Erro ao fechar caixa');
            }
          }

          onMounted(async function () {
            listOperators();
            listStores();
            const config = await Configuracoes.get();
            servicesEnabled.value = !!config?.services_enabled;
          });

          const deleteOperator = async () => {
            const resultado = await Operadores.deleteItem(Operador.id);
            closeModal();
            if (resultado === true) {
              feedback_error.value = false;
              msn_feedback.value = 'Operador deletado com sucesso!';
              listOperators();
            } else {
              // Ex.: operador já tem caixa/venda registrada — o dono
              // precisa ver o motivo real (e a sugestão de desativar em
              // vez de apagar), não só um "deu erro" silencioso.
              feedback_error.value = true;
              msn_feedback.value = resultado;
            }
            openModal('modal_feedback');
          }

          const updateOperator = async () => {
            const resultado = await Operadores.updateItem(Operador);
            if (resultado === true) {
              feedback_error.value = false;
              msn_feedback.value = "Operador atualizado com sucesso!"
              closeModal();
              listOperators();
            } else {
              feedback_error.value = true;
              msn_feedback.value = resultado;
            }
            openModal('modal_feedback');
          }

          const actionOperator = () => {
            if (edit.value) {
              updateOperator();
            } else {
              saveOperator();
            }
          }

          return {
            Operador,
            servicesEnabled,
            msn_feedback,
            feedback_error,
            autorizated_delet,
            edit,
            lista_operadores,
            lista_lojas,
            openModal,
            show_editOperator,
            show_newOperator,
            show_deletOperator,
            deleteOperator,
            actionOperator,
            closeCashier
          }
        },
      }
  </script>
